import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { App } from './App.js';
import { defaultSocketUrl, startConnection } from './store.js';
import { codeFromPath } from './codes.js';

const connection = startConnection(defaultSocketUrl(), codeFromPath(window.location.pathname));

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App onRetry={() => connection.retryNow()} />
    </StrictMode>,
  );
}
